// source: server/screening.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData', null, global);
goog.exportSymbol('proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.displayName = 'proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.displayName = 'proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.prototype.toObject = function(opt_includeInstance) {
  return proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.toObject = function(includeInstance, msg) {
  var f, obj = {
miraibaraiInternal: (f = msg.getMiraibaraiInternal()) && proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData}
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData;
  return proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData}
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting;
      reader.readMessage(value,proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.deserializeBinaryFromReader);
      msg.setMiraibaraiInternal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMiraibaraiInternal();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.serializeBinaryToWriter
    );
  }
};


/**
 * optional MiraibaraiInternalApiSetting miraibarai_internal = 1;
 * @return {?proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting}
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.prototype.getMiraibaraiInternal = function() {
  return /** @type{?proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting, 1));
};


/**
 * @param {?proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting|undefined} value
 * @return {!proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData} returns this
*/
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.prototype.setMiraibaraiInternal = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData} returns this
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.prototype.clearMiraibaraiInternal = function() {
  return this.setMiraibaraiInternal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.kipp_corp.core.grpc.server.ExternalScreeningApiSettingData.prototype.hasMiraibaraiInternal = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
endpointUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
bearerToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
graphqlQueryTemplate: jspb.Message.getFieldWithDefault(msg, 3, ""),
webhookUri: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting;
  return proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndpointUri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBearerToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphqlQueryTemplate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebhookUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBearerToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGraphqlQueryTemplate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWebhookUri();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string endpoint_uri = 1;
 * @return {string}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.getEndpointUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} returns this
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.setEndpointUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bearer_token = 2;
 * @return {string}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.getBearerToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} returns this
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.setBearerToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string graphql_query_template = 3;
 * @return {string}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.getGraphqlQueryTemplate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} returns this
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.setGraphqlQueryTemplate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string webhook_uri = 4;
 * @return {string}
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.getWebhookUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting} returns this
 */
proto.com.kipp_corp.core.grpc.server.MiraibaraiInternalApiSetting.prototype.setWebhookUri = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.com.kipp_corp.core.grpc.server);
